export default __webpack_public_path__ + "static/media/Diabetes.dd359e5b.svg";